<template>
  <nav class="nav">
    <div class="nav-wrapper">
      <router-link to="/"
                   :class="{'nav-item-active' : $route.name === 'home'}"
                   class="nav-item">
        首页
      </router-link>
      <router-link to="/convert/pdfConvert/pdfToWord"
                   :class="{'nav-item-active' : $route.path.match('pdfConvert')}"
                   class="nav-item">
        PDF转换
        <div class="nav-convert">
          <div class="nav-convert-wrapper">
            <router-link to="/convert/pdfConvert/pdfToWord"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PDF转word
            </router-link>
            <router-link to="/convert/pdfConvert/pdfToImage"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PDF转图片
            </router-link>
            <router-link to="/convert/pdfConvert/pdfToPPT"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PDF转PPT
            </router-link>
            <router-link to="/convert/pdfConvert/pdfToExcel"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PDF转Excel
            </router-link>
            <router-link to="/convert/pdfConvert/pdfToTxt"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PDF转TXT
            </router-link>
          </div>
        </div>
      </router-link>
      <router-link to="/convert/convertToPdf/wordToPdf"
                   :class="{'nav-item-active' : $route.path.match('convertToPdf')}"
                   class="nav-item">
        转换成PDF
        <div class="nav-convert">
          <div class="nav-convert-wrapper">
            <router-link to="/convert/convertToPdf/wordToPdf"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              word转PDF
            </router-link>
            <router-link to="/convert/convertToPdf/imageToPdf"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              图片转PDF
            </router-link>
            <router-link to="/convert/convertToPdf/PPTToPdf"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PPT转PDF
            </router-link>
            <router-link to="/convert/convertToPdf/excelToPDF"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              Excel转PDF
            </router-link>
          </div>
        </div>
      </router-link>
      <router-link to="/convert/cadConvert/pdfToCad"
                   :class="{'nav-item-active' : $route.path.match('cadConvert')}"
                   class="nav-item">
        CAD转换
        <div class="nav-convert">
          <div class="nav-convert-wrapper">
            <router-link to="/convert/cadConvert/pdfToCad"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              PDF转CAD
            </router-link>
            <router-link to="/convert/cadConvert/cadToPdf"
                         active-class="nav-convert-item-active"
                         class="nav-convert-item">
              CAD转PDF
            </router-link>
          </div>
        </div>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Nav'
}
</script>

<style lang="less">
@import "../../assets/style/styleVariable";
@import "../../assets/style/styleMixins";
.nav{
  background-color: #548EF8;
  height: 60px;
  &-wrapper{
    width: @page_width;
    height: 100%;
    margin: 0 auto;
    display: flex;
  }
  &-item{
    padding: 22px 39px;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    position: relative;
    &:hover{
      background: #6460FA;
      > .nav-convert{
        opacity: 1;
        pointer-events: all;
      }
    }
    &-active{
      background: #6460FA;
    }
  }
  &-convert{
    opacity: 0;
    pointer-events: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 65px;
    transition: opacity .3s;
    &-wrapper{
      display: flex;
      flex-direction: column;
      width: 100%;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      border-radius: 4px;
      &::before{
        content: '';
        width: 0;
        height: 0;
        border-width: 10px 10px;
        border-style: solid;
        border-color: transparent transparent #FFFFFF;
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    &-item{
      font-size: 16px;
      padding: 17px 0;
      text-align: center;
      color: #666666;
      &:hover{
        background:rgba(84, 142, 248, 0.2);
        color: #548EF8;
      }
      &-active{
        background:rgba(84, 142, 248, 0.2);
        color: #548EF8;
      }
    }
  }
}
</style>
